import { STORAGE_URL } from '@/configs';

/**
 * Registers public/sw.js (production builds only) so the player can boot and play offline.
 * Browsers without service-worker support simply keep the online-only behaviour.
 */
export const registerServiceWorker = () => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    let storageOrigin = '';
    try {
      storageOrigin = new URL(STORAGE_URL).origin;
    } catch {
      // Without a storage origin the worker still caches the app shell.
    }

    navigator.serviceWorker
      .register(`/sw.js?storage=${encodeURIComponent(storageOrigin)}`)
      .catch((error) =>
        console.error('Service worker registration failed', error),
      );
  });
};
